import { CSSProperties, SVGProps, useId } from 'react';
import clsx from 'clsx/lite';
import styles from '@/components/service-showcase/ServiceShowcaseIcon.module.scss';

export const svgProps = {
  viewBox: '0 0 380 220',
  fill: 'none',
  width: '100%',
  'aria-hidden': true,
  focusable: false,
} satisfies SVGProps<SVGSVGElement>;

export function iconClassName(active: boolean, className?: string): string {
  return clsx(styles.icon, active && styles.active, className);
}

export function delay(value: string): CSSProperties {
  return { '--delay': value } as CSSProperties;
}

export function Glow(props: { cx: number; cy: number; r: number; opacity?: number }) {
  const { cx, cy, r, opacity = 0.2 } = props;
  const id = useId();

  return (
    <>
      <defs>
        <radialGradient id={id} cx='50%' cy='50%' r='50%'>
          <stop offset='0%' stopColor='currentColor' stopOpacity={opacity} />
          <stop offset='100%' stopColor='currentColor' stopOpacity='0' />
        </radialGradient>
      </defs>
      <circle cx={cx} cy={cy} r={r} fill={`url(#${id})`} />
    </>
  );
}

export { styles };
